import gsap from 'gsap';

export const WORD_REVEAL_CLASS = 'text-reveal-word';

export function splitTextIntoTokens(text: string): string[] {
  return text.split(/(\s+)/);
}

export function getWordElements(
  container: HTMLElement | null,
  className = WORD_REVEAL_CLASS,
): HTMLElement[] {
  if (!container) return [];
  return Array.from(container.querySelectorAll<HTMLElement>(`.${className}`));
}

export function setAllWordsToOpacity(
  container: HTMLElement | null,
  opacity: number,
  className = WORD_REVEAL_CLASS,
): void {
  if (!container) return;
  gsap.set(container.querySelectorAll(`.${className}`), { opacity });
}

export function createWordOpacityUpdater(
  words: HTMLElement[],
  fromOpacity: number,
  toOpacity: number,
): (progress: number) => void {
  return (progress: number) => {
    const total = words.length;
    if (!total) return;

    words.forEach((word, index) => {
      const segmentStart = index / total;
      const segmentEnd = (index + 1) / total;
      const segmentProgress = gsap.utils.clamp(
        0,
        1,
        (progress - segmentStart) / (segmentEnd - segmentStart),
      );
      gsap.set(word, {
        opacity: gsap.utils.interpolate(
          fromOpacity,
          toOpacity,
          segmentProgress,
        ),
      });
    });
  };
}

export function isWhitespaceToken(token: string): boolean {
  return /^\s+$/.test(token);
}
